import pinOne from './twistprint/1-pin.svg';
import pinFocusOne from './twistprint/1-focus.svg';
import checkOne from './twistprint/1-check.svg';

import pinTwo from './twistprint/2-pin.svg';
import pinFocusTwo from './twistprint/2-focus.svg';
import checkTwo from './twistprint/2-check.svg';

import pinThree from './twistprint/3-pin.svg';
import pinFocusThree from './twistprint/3-focus.svg';
import checkThree from './twistprint/3-check.svg';

import pinFour from './twistprint/4-pin.svg';
import pinFocusFour from './twistprint/4-focus.svg';
import checkFour from './twistprint/4-check.svg';

import pinFive from './twistprint/5-pin.svg';
import pinFocusFive from './twistprint/5-focus.svg';
import checkFive from './twistprint/5-check.svg';

import pinSix from './twistprint/6-pin.svg';
import pinFocusSix from './twistprint/6-focus.svg';
import checkSix from './twistprint/6-check.svg';

import pinSeven from './twistprint/7-pin.svg';
import pinFocusSeven from './twistprint/7-focus.svg';
import checkSeven from './twistprint/7-check.svg';

import parrotfyPinOne from './parrotfy/1-pin.svg';
import parrotfyPinFocusOne from './parrotfy/1-focus.svg';
import parrotfyCheckOne from './parrotfy/1-check.svg';

import parrotfyPinTwo from './parrotfy/2-pin.svg';
import parrotfyPinFocusTwo from './parrotfy/2-focus.svg';
import parrotfyCheckTwo from './parrotfy/2-check.svg';

import parrotfyPinThree from './parrotfy/3-pin.svg';
import parrotfyPinFocusThree from './parrotfy/3-focus.svg';
import parrotfyCheckThree from './parrotfy/3-check.svg';

import parrotfyPinFour from './parrotfy/4-pin.svg';
import parrotfyPinFocusFour from './parrotfy/4-focus.svg';
import parrotfyCheckFour from './parrotfy/4-check.svg';

import parrotfyPinFive from './parrotfy/5-pin.svg';
import parrotfyPinFocusFive from './parrotfy/5-focus.svg';
import parrotfyCheckFive from './parrotfy/5-check.svg';

import parrotfyPinSix from './parrotfy/6-pin.svg';
import parrotfyPinFocusSix from './parrotfy/6-focus.svg';
import parrotfyCheckSix from './parrotfy/6-check.svg';

import parrotfyPinSeven from './parrotfy/7-pin.svg';
import parrotfyPinFocusSeven from './parrotfy/7-focus.svg';
import parrotfyCheckSeven from './parrotfy/7-check.svg';

const icons = {
  twistprint: [
    {
      pin: pinOne,
      pinFocus: pinFocusOne,
      check: checkOne
    },
    {
      pin: pinTwo,
      pinFocus: pinFocusTwo,
      check: checkTwo
    },
    {
      pin: pinThree,
      pinFocus: pinFocusThree,
      check: checkThree
    },
    {
      pin: pinFour,
      pinFocus: pinFocusFour,
      check: checkFour
    },
    {
      pin: pinFive,
      pinFocus: pinFocusFive,
      check: checkFive
    },
    {
      pin: pinSix,
      pinFocus: pinFocusSix,
      check: checkSix
    },
    {
      pin: pinSeven,
      pinFocus: pinFocusSeven,
      check: checkSeven
    }
  ],
  parrotfy: [
    {
      pin: parrotfyPinOne,
      pinFocus: parrotfyPinFocusOne,
      check: parrotfyCheckOne
    },
    {
      pin: parrotfyPinTwo,
      pinFocus: parrotfyPinFocusTwo,
      check: parrotfyCheckTwo
    },
    {
      pin: parrotfyPinThree,
      pinFocus: parrotfyPinFocusThree,
      check: parrotfyCheckThree
    },
    {
      pin: parrotfyPinFour,
      pinFocus: parrotfyPinFocusFour,
      check: parrotfyCheckFour
    },
    {
      pin: parrotfyPinFive,
      pinFocus: parrotfyPinFocusFive,
      check: parrotfyCheckFive
    },
    {
      pin: parrotfyPinSix,
      pinFocus: parrotfyPinFocusSix,
      check: parrotfyCheckSix
    },
    {
      pin: parrotfyPinSeven,
      pinFocus: parrotfyPinFocusSeven,
      check: parrotfyCheckSeven
    }
  ]
};

export default icons;
